// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic__attachments{display:flex;flex-direction:column;overflow:hidden;gap:3px}.topic__attachments.topic__attachments--active .topic__attachments__body{margin-top:0}.topic__attachments__toggle-control{font-weight:bold;font-size:13px;padding:10px;transition:transform ease-in-out 250ms;background-color:#fff;border-radius:4px;transform:scale(1);text-align:center;cursor:pointer}@media(hover: hover){.topic__attachments__toggle-control:hover{transform:scale(0.95)}}", ""]);
// Exports
module.exports = exports;
